import React from 'react';
import PropTypes from 'prop-types';

import 'form_tooltip.scss';

const Direction = { LEFT: 'left', RIGHT: 'right' };

export const tooltipDefaultProp = {
  content: null,
  header: 'Help',
  position: Direction.LEFT,
};

export const tooltipPropShape = PropTypes.shape({
  content: PropTypes.node,
  header: PropTypes.string,
  position: PropTypes.string,
});

class FormTooltip extends React.Component {
  state = { hoverOnTooltip: false, inputFocused: false };

  render() {
    const { children, content, header, position } = this.props;
    const { inputFocused, hoverOnTooltip } = this.state;
    return content ? (
      <div>
        <div
          className="form-tooltip--children"
          onFocus={() => this.setState({ inputFocused: true })}
          onBlur={() => this.setState({ inputFocused: false })}
        >
          {children}
        </div>
        {(inputFocused || hoverOnTooltip) && (
          <div className={`form-tooltip--wrapper form-tooltip--wrapper__${position}`}>
            <div
              className="form-tooltip"
              onMouseEnter={() => this.setState({ hoverOnTooltip: true })}
              onMouseLeave={() => this.setState({ hoverOnTooltip: false })}
            >
              <h3 className="form-tooltip--header">{header}</h3>
              <div className="form-tooltip--content">{content}</div>
            </div>
          </div>
        )}
      </div>
    ) : (
      children
    );
  }
}

FormTooltip.propTypes = {
  children: PropTypes.node.isRequired,
  content: PropTypes.node,
  header: PropTypes.string,
  position: PropTypes.oneOf([Direction.LEFT, Direction.RIGHT]),
};

FormTooltip.defaultProps = tooltipDefaultProp;

export default FormTooltip;
